import { t } from '@web/i18n';
import { Input } from '@web/ui/core';
import { PremisesField } from './premises_field';
import type { PremisesForm } from './premises_form';

interface PremisesReturnFieldsProps {
  form: PremisesForm;
  canManage: boolean;
  onChange: (next: Partial<PremisesForm>) => void;
}

/** Janela de embarque da volta: o dia (vazio = toda volta), o ideal e o tolerado, mais cedo. */
export function PremisesReturnFields({
  form,
  canManage,
  onChange: patch,
}: Readonly<PremisesReturnFieldsProps>): React.JSX.Element {
  return (
    <>
      <h3 className="text-meta font-medium text-foreground">{t('mice.premises.return')}</h3>
      <div className="flex flex-wrap items-end gap-2">
        <PremisesField id="premises-return-date" label={t('mice.premises.returnDate')}>
          <Input
            id="premises-return-date"
            type="date"
            value={form.returnDate}
            disabled={!canManage}
            onChange={(e) => {
              patch({ returnDate: e.target.value });
            }}
          />
        </PremisesField>
        <PremisesField id="premises-return-ideal" label={t('mice.premises.returnEarliestIdeal')}>
          <Input
            id="premises-return-ideal"
            type="time"
            value={form.returnEarliestIdeal}
            disabled={!canManage}
            onChange={(e) => {
              patch({ returnEarliestIdeal: e.target.value });
            }}
          />
        </PremisesField>
        <PremisesField
          id="premises-return-tolerated"
          label={t('mice.premises.returnEarliestTolerated')}
        >
          <Input
            id="premises-return-tolerated"
            type="time"
            value={form.returnEarliestTolerated}
            disabled={!canManage}
            onChange={(e) => {
              patch({ returnEarliestTolerated: e.target.value });
            }}
          />
        </PremisesField>
      </div>
    </>
  );
}
